<template>
    <loading :active="loading"
             :can-cancel="true"
             :on-cancel="onCancel"
             :is-full-page="true"></loading>
    <modalView class="z-50" v-if="address_search_open" @close-modal="address_search_open = false" :harf="true"  >
      <address_search @set_address="set_address" @close_address_search="close_address_search" />
    </modalView>

    <div>
        <div >
            <ul class="border divide-slate-200 mt-5 relative"> <!-- class="mt-5 relative border-gray-400 border-solid"  class="border divide-slate-200 mt-5 relative"-->
                <li class="table w-full table-fixed border-b divide-slate-200">
                    <span class="block md:table-cell align-middle p-2.5 text-gray-700 w-full md:w-2/12 break-words border-r border-slate-200 bg-slate-300 font-normal">{{ i18n.myoffice.refund.profile}}</span>
                    <span class="block md:table-cell align-middle p-2.5 text-gray-700">{{ mem.userid }} ( {{ mem.username }})</span>
                </li>
                <li class="table w-full table-fixed border-b divide-slate-200">
                    <span class="block md:table-cell align-middle p-2.5 text-gray-700 w-full md:w-2/12 break-words border-r border-slate-200 bg-slate-300 font-normall">{{ i18n.myoffice.refund.orderNumber}}</span>
                    <span class="block md:table-cell align-middle p-2.5 text-gray-700"><div class="i_contents">{{ ord_no }}</div>
                        <p class="order_info">{{ i18n.myoffice.Order.PurchaseDate}}<span id="acc_dates"> {{ row.acc_dates }} </span>, {{ i18n.myoffice.Order.PastDueDate}} <span id="diff_days">{{ row.diff_days }}</span></p></span><!-- 구매일 : 경과기일 :-->
                </li>
                <li class="table w-full table-fixed border-b divide-slate-200">
                    <span class="block md:table-cell align-middle p-2.5 text-gray-700 w-full md:w-2/12 break-words border-r border-slate-200 bg-slate-300 font-normal">{{ i18n.myoffice.refund.applicationType}}</span>
                    <span class="block md:table-cell align-middle p-2.5 text-gray-700 item_content_label">
                        <label class='radio_input_box'><input type='radio' v-model="refund_type" value='refund_cancle' checked><span class='checkmark'></span>{{ i18n.myoffice.refund.cancel }}</label>
                        <label class='radio_input_box' v-if="row_deli.r_city == 'USA' && row_deli.deli_kind !='1'"><input type='radio' v-model="refund_type" value='change_address'><span class='checkmark'></span>{{ i18n.myoffice.refund.changeShippingAddress }}</label>
                    </span>
                </li>
                <li class="table w-full table-fixed border-b divide-slate-200 " v-show="refund_type == 'change_address'">
                    <span class="block md:table-cell align-middle p-2.5 text-gray-700 w-full md:w-2/12 break-words border-r border-slate-200 bg-slate-300 font-normal hidden md:block">
                        <span v-show="r_type == 'C'">Shipping address to be changed</span>
                        <span v-show="r_type != 'C'">{{ i18n.myoffice.Address}}</span>
                    </span>
                    <span class="table-cell align-middle p-2.5 text-gray-700">
                        <ul class="mgb_30">
                            <li class="table w-full table-fixed border-b divide-slate-200">
                                <span class="block md:table-cell align-middle p-2.5 text-gray-700 w-full md:w-2/12 break-words border-r border-slate-200 bg-slate-300 font-normal">{{ i18n.myoffice.Form.Reciever}}</span>
                                <span class="block md:table-cell align-middle p-2.5 text-gray-700 item_content_label m_contents z-30 relative">
                                  <input type="text" placeholder="Reciever" v-model='d_name'
                                         class="w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600 h-11">
                                </span>
                            </li>
                            <li class="table w-full table-fixed border-b divide-slate-200">
                                <span class="block md:table-cell align-middle p-2.5 text-gray-700 w-full md:w-2/12 break-words border-r border-slate-200 bg-slate-300 font-normal">Mobile</span>
                                <span class="block md:table-cell align-middle p-2.5 text-gray-700 item_content_label m_contents z-30 relative">
                                      <input type="text" placeholder="Mobile" v-model='d_mobile'
                                     class="w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600 h-11">
                                </span>
                            </li>
                            <!-- 주소지 영역-->
                            <li class="table w-full table-fixed border-b divide-slate-200">
                                <span class="block md:table-cell align-middle p-2.5 text-gray-700 w-full md:w-2/12 break-words border-r border-slate-200 bg-slate-300 font-normal">Address</span>
                                <span class="block md:table-cell align-middle p-2.5 text-gray-700 item_content_label m_contents">
                                    <input class="w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600 mb-px h-11" v-model="d_addr2_1" type="text" placeholder="Street Address">
                                    <input class="w-full px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600 mb-px h-11" v-model="d_addr2_2" type="text" placeholder="Apt, Ste, Unit, etc">
                                    <input @click="search_address"  name="d_post" id="d_post" class="w-1/2 px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600 mb-px h-11" v-model="d_post" type="text" placeholder="Zip Code">
                                    <input type="button" @click="search_address" value="search address" class="bg-indigo-500 font-semibold hover:bg-[#2468a0] py-3 text-sm text-white uppercase w-1/2">
                                    <input @click="search_address"  name="d_city" id="d_city" class="w-1/2 px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600 mb-px h-11" v-model="d_city" type="text" placeholder="CITY">
                                  <input @click="search_address"  name="d_state" id="d_state" class="w-1/2 px-4 py-3 text-sm border border-gray-300 rounded lg:text-sm focus:outline-none focus:ring-1 focus:ring-blue-600 mb-px h-11" v-model="d_state" type="text" placeholder="STATE">
                                </span>
                            </li>
                        </ul>
                    </span>
                </li>
            </ul>
            <div id="cancelOrderRefund" style="margin:20px 0; padding:0 15px;">
                <div class="myo_condition_search2">
                    <button type="submit" class="search_btn" v-on:click="submitForm" v-show="row.processing < 20">{{ i18n.myoffice.refund.apply }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import alert from "vue3-simple-alert";
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import vSelect from "vue-select";
import modalView from "../../modalView";
import VueSimpleAlert from "vue3-simple-alert";

export default {
    name: "MyViewOrderCancel",
    components : {
        alert,
        Loading,
        vSelect,
        modalView
    },
    props : {
        ord_no : String,
        r_type : String,
        searchType : String,
        schUserId : String,
    },
    data: () => ({
        i18n: window.i18n,
        row: "",
        mem : "",
        refund_type: "refund_cancle",
        loading : false,
        d_name : "",
        d_mobile : "",
        d_state : "",
        d_city : "",
        d_post : "",
        address_search_open:false,
        row_deli : "",
        r_state : "",
        d_addr2_1 : "",
        d_addr2_2 : "",
    }),
    watch : {
      d_mobile : function(val){
        return this.d_mobile = this.d_mobile.replace(/[^0-9]/g, '');
      },
    },
    created(){
        this.loading = true;
        axios.post(window.Laravel.back_url+'/api/getOrdMst',{
            ord_no : this.ord_no,
        },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }}).then(response => {
            if(response.data.c_num != ""){
                alert.alert("이미 신청한 기록이 있습니다.","","",{allowOutsideClick : false}).then(r => {
                    this.$emit('close-modal');
                    location.replace("/MyOrderCancel");
                });
            }
            //배송지 주소 로딩
            axios.post(window.Laravel.back_url+'/api/getOrdDeli',{
              ord_no : this.ord_no,
            },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }}).then(response2 => {
              this.row_deli = response2.data.row_deli;
              this.r_state = (this.row_deli.r_addr1).split("|@|")[1];

              this.row = response.data.row;
              this.mem = response.data.mem;
              this.loading = false;
            });

        });
    },
    methods : {
        submitForm : function (){
            this.loading = true;
            var url = "orderCancel";
            if(this.refund_type == "change_address"){
                url = "shippingChange";
            }

            axios.post(window.Laravel.back_url+'/api/'+url,{
              refund_type : this.refund_type,
              d_addr2 : this.d_addr2_1 + "|@|" + this.d_addr2_2,
              d_mobile : this.d_mobile,
              d_name : this.d_name,
              ord_no : this.ord_no,
              d_post : this.d_post,
              d_state : this.d_state,
              d_city : this.d_city,
              processing : 1,
              cmemo : ''
            },{headers: { Authorization: 'Bearer ' + window.Laravel.access_token }}).then(response => {
                if(response.data.result == "0"){
                  alert(response.data.msg);
                  return;
                }
                alert.alert(response.data.msg,"","",{allowOutsideClick : false}).then(r => {
                    this.$emit('close-modal');
                    window.location.reload();
                });
                this.loading = false;

                // this.row = response.data.row;
                // this.list_temp_str = response.data.list_temp_str;
                // this.loading = false;
            });

        },
        search_address(){
          this.address_search_open = true;
        },
        set_address(value){
          if(value.state != this.r_state){
            alert.alert("You can only change the delivery address within the state that you ordered.","","",{});
            return;
          }
          this.address_search_open = false;
          this.d_state =value.state;
          this.d_city = value.district;
          this.d_post = value.postcode;

        },
        close_address_search(){
          this.address_search_open = false;
        }

    }

}
</script>

<style>
</style>
